// Helper function לניקוי localStorage keys של הטור לצורך בדיקה
export const clearAllTourKeys = () => {
  const keys = [
    'bmc_welcome_seen',
    'bmc_catalog_tour_done', 
    'bmc_vehicle_tour_done',
    'bmc_offers_tour_done',
    'bmc_first_offer_submitted'
  ];
  
  keys.forEach(key => {
    // נקה גם עם userId וגם בלי
    localStorage.removeItem(key);
    
    // נקה גם עם userId אם קיים
    const userId = localStorage.getItem('userId') || '1';
    localStorage.removeItem(`${key}_${userId}`);
  });
  
  console.log('All tour localStorage keys cleared');
};

// הוסף לחלון הגלובלי לצורך בדיקה
if (typeof window !== 'undefined') {
  window.clearAllTourKeys = clearAllTourKeys;
}